import React from 'react';
import { Icon, Floating } from '@haldor/ui';

var DropDownList = function DropDownList(props) {
  return /*#__PURE__*/React.createElement(Floating, {
    trigger: /*#__PURE__*/React.createElement("button", {
      className: "c--button dropdown"
    }, props.label, /*#__PURE__*/React.createElement(Icon, {
      name: "Chevron_Down",
      style: {
        marginLeft: '2rem'
      }
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropDownContainer"
  }, props.children));
};

export default DropDownList;